const TRANSLATION = {
  common: {
    loading: 'Chargement',
  },
  i18n: {
    English: 'Anglais',
    Spanish: 'Espagnol',
    Russian: 'Russe',
    'Portuguese (Brazil)': 'Portugais (Brésil)',
    Indonesian: 'Indonésien',
    Czech: 'Tchèque',
    German: 'Allemand',
    French: 'Français',
    Italian: 'Italien',
    Dutch: 'Néerlandais',
    Polish: 'Polonais',
    Vietnamese: 'Vietnamien',
    Turkish: 'Turc',
    Ukrainian: 'Ukrainien',
    Chinese: 'Chinois simplifié',
    'Traditional Chinese': 'Chinois traditionnel',
    Japanese: 'Japonais',
    Korean: 'Coréen',
    Arabic: 'Arabe',
    Persian: 'Persan',
    Thai: 'Thaï',
    Hindi: 'Hindi',
    Malay: 'Malaisien',
    province: {
      Hebei: 'Province du Hebei',
      Shanxi: 'Province du Shanxi',
      Liaoning: 'Province du Liaoning',
      Jilin: 'Province du Jilin',
      Heilongjiang: 'Province du Heilongjiang',
      Jiangsu: 'Province du Jiangsu',
      Zhejiang: 'Province du Zhejiang',
      Anhui: 'Province de l’Anhui',
      Fujian: 'Province du Fujian',
      Jiangxi: 'Province du Jiangxi',
      Shandong: 'Province du Shandong',
      Henan: 'Province du Henan',
      Hubei: 'Province du Hubei',
      Hunan: 'Province du Hunan',
      Guangdong: 'Province du Guangdong',
      Hainan: 'Province du Hainan',
      Sichuan: 'Province du Sichuan',
      Guizhou: 'Province du Guizhou',
      Yunan: 'Province du Yunnan',
      Shaanxi: 'Province du Shaanxi',
      Gansu: 'Province du Gansu',
      Qinghai: 'Province du Qinghai',
      Taiwan: 'Province de Taïwan',
      Guangxi: 'Région autonome Zhuang du Guangxi',
      Neimenggu: 'Région autonome de Mongolie-Intérieure',
      Tibet: 'Région autonome du Tibet',
      Ningxia: 'Région autonome Hui du Ningxia',
      Xinjiang: 'Région autonome ouïghoure du Xinjiang',
      HongKong: 'Région administrative spéciale de Hong Kong',
      Macau: 'Région administrative spéciale de Macao',
      Beijing: 'Municipalité de Pékin',
      Tianjin: 'Municipalité de Tianjin',
      Shanghai: 'Municipalité de Shanghai',
      Chongqing: 'Municipalité de Chongqing',
    },
  },
  pageHeader: {
    product: 'Produit',
    tvcTest: 'Test d’expérience TVC',
    tvcEval: 'Évaluation créative TVC',
    contactUs: 'Contactez-nous',
    Pricing: 'Tarification',
    Dashboard: 'Commencer maintenant',
    signIn: 'Se connecter',
    signUp: 'S’inscrire',
    resourceCenter: 'Blog',
    all: 'Tous',
    news: 'News',
    insight: 'Insight',
    case: 'Case',
  },
  productSwitch: {
    common: {
      comingSoon: 'Bientôt disponible',
    },
    modal: {
      heroTitle: 'Veuillez sélectionner le test que vous souhaitez lancer',
      heroSubtitle:
        'AdEff est prêt à vous fournir des insights créatifs multidimensionnels à tout moment.',
      remainingTimes: 'Essais restants : {{count}}',
      supportedAssets: 'Supports compatibles',
      coreMetrics: 'Indicateurs clés',
      cognitiveNeuroscienceIndicators: 'Indicateurs cognitivo-neuronaux',
      consumerAttitudeIndicators: 'Indicateurs d’attitude consommateur',
      outputResult: 'Résultat de sortie',
      dataReport: 'Rapport de données',
      analysisReport: 'Rapport d’analyse',
      accessBackend: 'Commencer maintenant',
      tabs: {
        tvc: 'Test créatif horizontal',
        portrait: 'Test créatif vertical',
      },
      cards: {
        tvcQuick: {
          title: 'Horizontal-Test rapide',
          descriptionHighlight:
            'Évaluez rapidement les créations pour guider des décisions fondées sur les données',
        },
        tvcBase: {
          title: 'Diagnostic créatif-horizontal',
          descriptionHighlight:
            'Affinez les détails créatifs avec des suggestions de modification actionnables',
          value1: 'Créatifs TVC/OTV de 10 à 60 s',
          value2: 'Indicateurs cognitivo-neuronaux',
        },
        tvcSurvey: {
          title: 'InsightPro-horizontal',
          descriptionHighlight:
            'Analyse créative multidimensionnelle avec des orientations stratégiques d’optimisation',
          value1: 'Créatifs TVC/OTV de 10 à 60 s',
          value2: 'Indicateurs cognitivo-neuronaux',
        },
        portraitQuick: {
          title: 'Vertical-Test rapide',
          descriptionHighlight:
            'Évaluez rapidement les créations pour guider des décisions fondées sur les données',
        },
        portraitBase: {
          title: 'Diagnostic créatif-vertical',
          descriptionHighlight:
            'Affinez les détails créatifs avec des suggestions de modification actionnables',
          value1: 'Créatifs verticaux de 5 à 90 s',
          value2: 'Indicateurs cognitivo-neuronaux',
        },
        portraitSurvey: {
          title: 'InsightPro-vertical',
          descriptionHighlight:
            'Analyse créative multidimensionnelle avec des orientations stratégiques d’optimisation',
          value1: 'Créatifs verticaux de 5 à 90 s',
          value2: 'Indicateurs cognitivo-neuronaux',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Test créatif horizontal',
          assetText: 'Pour les créations TVC/OTV de 10 à 60 s',
        },
        portrait: {
          bannerTitle: 'Test créatif vertical',
          assetText: 'Pour les créations verticales de 5 à 90 s',
        },
      },
      items: {
        tvcQuick: {
          description: 'Comparez rapidement les créations et décidez',
        },
        tvcBase: {
          title: 'Diagnostic créatif',
          description: 'Optimisation seconde par seconde pour affiner les créations',
        },
        tvcSurvey: {
          title: 'Analyse approfondie',
          description: 'Analyse complète pour identifier précisément les problèmes',
        },
        portraitBase: {
          title: 'Diagnostic créatif',
          description: 'Optimisation seconde par seconde pour affiner les créations',
        },
        portraitQuick: {
          description: 'Comparez rapidement les créations et décidez',
        },
        portraitSurvey: {
          title: 'Analyse approfondie',
          description: 'Analyse complète pour identifier précisément les problèmes',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Utilisation des cookies',
    desc: 'Nous utilisons des cookies nécessaires pour garantir le bon fonctionnement de notre site Web. Avec votre consentement, nous utilisons également des cookies d’analyse pour améliorer votre expérience utilisateur. Consultez notre politique de cookies dans notre politique de confidentialité.',
    btn1: 'Tout refuser',
    btn2: 'Tout accepter',
    cookiePolicy: 'Politique de cookies',
  },
  landing: {
    banner: {
      text1: 'Basé sur l’IA',
      text2: 'Publicité',
      text3: 'Test',
      text4: 'Plateforme de test et d’optimisation créative',
      feature1: 'Décodage de contenu',
      feature2: 'Prévision de feedback',
      feature3: 'Intégration de données',
      feature4: 'Raisonnement des conclusions',
      btn1: 'Obtenir une démo',
      btn2: 'Créer un projet',
    },
    info: {
      title:
        'Basé sur le modèle de langage multimodal HMLLM*, prévoyez rapidement l’efficacité créative et améliorez le retour sur investissement publicitaire',
      subTitle:
        '*Ce modèle est basé sur un grand nombre de tests en neurosciences marketing et de constructions multi-agents',
      detail1: 'Tests publicitaires rapides',
      detail1Desc:
        'AdEff peut obtenir en 15 minutes la courbe d’attention de l’audience cible, les fluctuations émotionnelles et l’engagement avec le contenu créatif, et fournir un rapport d’évaluation détaillé et des conseils d’optimisation.',
      detail2: 'Sélection rapide des meilleures créations',
      detail2Desc:
        'AdEff prend en charge la mesure simultanée de plusieurs créations, aidant les marques à prendre des décisions rapides. Fournit également une analyse comparative détaillée.',
      detail3: 'Génération de versions efficaces et variées en un clic',
      detail3Desc:
        'AdEff prend en charge la génération rapide de versions efficaces et variées en un clic, adaptées à divers scénarios de diffusion.',
    },
    advantages: {
      title: 'Avantages d’AdEff',
      item1Title: 'Réponse rapide',
      item1Desc: 'Rapport disponible en moins de <tmp>15 minutes</tmp>.',
      item2Title: 'Modèle d’IA unique',
      item2Desc: 'Modèle d’IA basé sur le feedback de l’audience <tmp>unique</tmp>.',
      item3Title: 'Graphiques de visualisation',
      item3Desc:
        '<tmp>Graphiques de visualisation</tmp> + interprétation par IA, rapport de test généré en un clic',
      item4Title: 'Large éventail de données',
      item4Desc: '<tmp>50,000+</tmp> base de données créatives',
      item5Title: 'Équipe d’experts',
      item5Desc: '<tmp>Équipe d’experts</tmp> fournissant soutien et conseils',
    },
    service: {
      title: 'Modes de service d’AdEff',
      desc: 'Choisissez le mode de service dont vous avez besoin',
      topTitle: 'Service autonome en ligne',
      topRow1: 'Créez des projets de manière autonome et terminez les tests',
      topRow2: 'Graphiques de visualisation + rapport d’interprétation par IA',
      topRow3: 'Analyse des indicateurs neuroscientifiques objectifs (regard + EEG)',
      topRow4: 'Tests avec un modèle d’IA unique',
      bottomTitle: 'Service d’équipe d’experts',
      bottomRow1: 'Tests réalisés par des experts',
      bottomRow2:
        'Analyse des indicateurs neuroscientifiques objectifs (regard + EEG), option d’ajout d’indicateurs subjectifs',
      bottomRow3: 'Graphiques de visualisation + rapport d’interprétation par experts',
      bottomRow4: 'Tests avec un modèle d’IA unique, option de tests avec échantillons réels',
    },
    footer: {
      title:
        'AdEff repose sur le modèle de langage multimodal HMLLM, construisant des relations complexes entre les signaux EEG des éléments visuels et les données de suivi oculaire via un hypergraphe, permettant un test rapide des créations publicitaires',
      email: 'E-mail',
      belongDesc: 'Produit de <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Commencer maintenant',
  },
  contact: { title: 'Contactez-nous', copy: 'Copier', message: { success: 'Copie réussie' } },
  pricing: {
    title: "Expert en test et optimisation créative piloté par l'IA",
    starter: {
      title: 'Démarreur',
      desc_1: "Convient aux tests uniques, prêt à utiliser après l'achat",
      desc_2: "Convient aux tests à petite échelle, prêt à utiliser après l'achat",
      timesDesc: '<strong>{{count}}</strong> fois test',
      timesDesc1: '<strong>{{count}}</strong> fois test',
      discount: '50% de réduction',
      originPrice: 'Prix original',
      desc2: "Modèle de langage multimodal HMLLM basé sur le feedback de l'audience",
      desc3: 'Réponse rapide, rapport généré en 15 minutes',
      desc4: 'Graphiques de visualisation riches',
      desc5: 'Interprétation intelligente par IA professionnelle',
      desc6: 'Base de données et références mondiales',
      cardDesc1: 'Remise limitée, seulement {{pricePerTest}}',
      cardDesc2: 'Le quota de tests n’expire jamais',
    },
    premium: {
      time: 'fois',
    },
    unlimited: {
      title: 'Illimité',
      cardDesc1: 'À partir de {{pricePerTest}}',
      cardDesc2: 'Quota valable un an',
      cardDesc3: 'Benchmark propriétaire personnalisé',
      planDesc500: 'Profitez de 500 tests tout au long de l’année',
      planDesc1000: 'Profitez de 1 000 tests tout au long de l’année',
    },
    benefits: {
      title: 'Pourquoi choisir AdEff ?',
      subtitle: 'Avec AdEff, vous pouvez bénéficier des avantages suivants :',
      expertSupport: 'Support et accompagnement par une équipe d’experts',
      moreNeedsTitle: 'Vous avez d’autres besoins d’achat ?',
      customPlanPrefix: 'Nous proposons des offres flexibles et personnalisées — contactez-nous à',
      customPlanSuffix: 'pour votre solution sur mesure',
    },
    subscribeBtn: 'S’abonner maintenant',
    contactUs: 'Contactez-nous',
  },
  login: {
    loginText: 'Se connecter',
    signUpText: '<tmp>S’inscrire</tmp> gratuitement',
    text1: 'Rejoint l’équipe avec succès',
    text1Desc: 'Vous pouvez tester les publicités par vous-même',
    text2: 'L’utilisateur a rejoint l’entreprise',
    text3: 'L’invitation de l’équipe a expiré',
    text4: 'Le lien d’invitation de l’équipe n’est plus valide.',
    optionText1: 'Vous avez déjà un compte ?',
    optionText2: 'Vous n’avez pas de compte ?',
    alertText1: 'En m’inscrivant, j’accepte',
    alertText2: 'Je accepte',
    termsOfService: 'Conditions de service',
    privacy: 'Politique de confidentialité',
    privacyTips: "Veuillez cocher la case d'accord avant de vous inscrire.",
    and: 'et',
    or: 'ou',
    next: 'Suivant',
    googleLogin: 'Se connecter avec Google',
    googleSignUp: 'S’inscrire avec Google',
    loginWithEmail: 'Se connecter avec un e-mail',
    signUpWithEmail: 'S’inscrire avec un e-mail',
    password: 'Mot de passe',
    emailAddress: 'Adresse e-mail',
    enterEmail: 'Entrez votre adresse e-mail',
    enterPassword: 'Entrez votre mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    inconsistentPassword: 'Les mots de passe ne correspondent pas',
    verificationCode: 'Code de vérification',
    emptyVerificationCode: 'Le code de vérification ne peut pas être vide',
    enterVerificationCode: 'Entrez le code de vérification',
    sendedVerificationCode: 'Le code de vérification a été envoyé à votre e-mail',
    emailOrPasswordNotCorrect: 'L’adresse e-mail ou le mot de passe est incorrect.',
    message: {
      text1: 'Le contenu saisi est invalide',
      text2: 'L’adresse e-mail est déjà enregistrée',
      text3: 'Erreur de vérification du code de vérification !',
      text4: 'Ce compte n’est pas lié à l’entreprise, veuillez le lier à nouveau !',
      text5: 'Veuillez entrer un format d’e-mail correct',
      text6: 'Le mot de passe doit contenir au moins 12 caractères',
      text7: 'Le mot de passe doit contenir des lettres majuscules, minuscules et des chiffres',
      requestLimit: 'Demande limitée, veuillez réessayer plus tard',
    },
  },
  resetPwdPage: {
    submit: 'Envoyer',
    emailNotFound: 'Veuillez vérifier votre adresse e-mail',
    emailHasSent: 'L’adresse e-mail a été envoyée à {{email}}',
    checkYourInbox: 'Vérifiez votre boîte e-mail',
    resetYourPassword: 'Réinitialiser le mot de passe',
    resetLinkHasSent:
      'Un lien pour réinitialiser votre mot de passe a été envoyé à l’adresse e-mail associée à votre compte',
    enterYourEmailAddress:
      'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe',
    didNotGetEmail: 'Vous n’avez pas reçu d’e-mail ?',
    tryAgain: 'Réessayer',
    goBackToSign: 'Retour à la connexion',
    email: 'E-mail',
    enterYourEmail: 'Entrez votre adresse e-mail',
    resetPassword: 'Réinitialiser le mot de passe',
    resetPwdSuccess: 'Mot de passe réinitialisé avec succès',
    message: {
      resetLinkCodeError: 'Le code dans le lien est invalide',
      requestLimit: 'Demande limitée, veuillez réessayer plus tard',
    },
  },
  memberRequestPage: {
    title: 'Vérification de la demande de membre',
    subTitle: 'Demande provenant de :',
    deny: 'Refuser',
    approve: 'Approuver',
    teamFull: 'L’équipe est complète',
    yourTeamIsFull:
      'Votre équipe est pleine. Vous pouvez nous contacter pour obtenir plus de membres ou supprimer d’autres membres.',
    manageMembers: 'Gérer les membres dans AdEff',
    requestApproved: 'Demande approuvée',
    approvedDesc:
      'Vous avez approuvé <tmp>{{name}}</tmp> pour rejoindre votre équipe, un e-mail de notification a été envoyé automatiquement.',
    requestDeclined: 'Demande refusée',
    declinedDesc:
      'Vous avez refusé <tmp>{{name}}</tmp> pour rejoindre votre équipe, un e-mail de notification a été envoyé automatiquement.',
  },
  infoBindPage: {
    title: 'Test publicitaire basé sur l’IA',
    desc: 'Basé sur le modèle de langage multimodal HMLLM*, prévoyez rapidement l’efficacité créative et améliorez le retour sur investissement publicitaire',
    joinAdEff: 'Rejoignez AdEff et commencez un nouveau voyage',
    advantages: {
      title1: 'Plus puissant',
      desc1: 'Modèle d’IA unique basé sur une vaste base de données',
      title2: 'Plus économique',
      desc2: 'Pour seulement 10 % du prix des méthodes traditionnelles',
      title3: 'Plus rapide',
      desc3: 'Rapport disponible en 15 minutes maximum',
      title4: 'Plus professionnel',
      desc4: 'Bénéficiez d’un support 24/7 et d’un service d’équipe d’experts',
    },
    username: 'Nom d’utilisateur',
    company: 'Société',
    placeOfResidence: 'Pays/Région',
    invitationCode: 'Code de parrainage',
    createAccountForFree: 'Créer un compte gratuitement',
    refreshStatus: 'Actualiser le statut',
    reapply: 'Réappliquer',
    bySigningUp: 'En m’inscrivant, j’accepte',
    termsOfService: 'Conditions de service',
    and: 'et',
    privacyPolicy: 'Politique de confidentialité',
    message: {
      success: 'Demande de création de compte envoyée, veuillez patienter !',
      success2: 'Compte créé avec succès',
      error: 'Échec de la création du compte, veuillez réessayer plus tard.',
      accountCreatedDirectly: 'Votre compte a été créé directement !',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'La demande a été approuvée, la page va se rediriger automatiquement.',
      theRequestHasBeenSendAndPleaseBePatient: 'La demande a été envoyée, veuillez patienter !',
      wrongRouting: 'Erreur de routage, la page va se rediriger automatiquement.',
      yourRequestHasBeenDeclined:
        'Votre demande a été refusée. Vous pouvez réappliquer pour rejoindre l’équipe ou créer un nouveau compte sans code d’invitation.',
      waitingForAdministratorReview: 'En attente de l’examen de l’administrateur',
      thisFieldIsRequired: 'Ce champ est requis',
      pleaseEnterTheResidence: 'Veuillez entrer le pays',
      invitationCodeDoesNotExist: 'Code de parrainage invalide',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        "Si vous utilisez ceci par le biais d'un parrainage d'agent, veuillez entrer le code de parrainage",
      pleaseEnterTheUsername: 'Veuillez entrer le nom d’utilisateur',
      pleaseEnterTheCompanyName: 'Veuillez entrer le nom de la société',
      needRegisterAgain: 'Erreur dans l’opération, veuillez vous inscrire à nouveau',
      alreadyBind: 'Vous avez déjà lié l’entreprise, veuillez ne pas la lier à nouveau',
    },
  },
  knowledgeFormPage: {
    name: 'Votre nom',
    email: 'Votre adresse e-mail',
    companyName: 'Nom de l’entreprise',
    department: 'Département',
    role: 'Poste',
    country: 'Pays',
    province: 'Province',
    pleaseEnter: 'Veuillez saisir',
    pleaseSelect: 'Veuillez sélectionner',
    pleaseEnterTheName: 'Veuillez saisir votre nom',
    pleaseEnterTheEmail: 'Veuillez saisir votre adresse e-mail',
    pleaseEnterValidEmail: 'Veuillez saisir une adresse e-mail valide',
    pleaseEnterTheCompanyName: 'Veuillez saisir le nom de votre entreprise',
    pleaseSelectTheDepartment: 'Veuillez sélectionner votre département',
    pleaseSelectTheRole: 'Veuillez sélectionner votre poste',
    pleaseSelectTheCountry: 'Veuillez sélectionner votre pays',
    pleaseSelectTheProvince: 'Veuillez sélectionner votre province',
    textIsRequired: 'Ce champ est requis',
    submit: 'Soumettre',
    download: 'Télécharger',
    submitSuccess: 'Demande envoyée avec succès',
    downloadSuccess: 'Téléchargement réussi',
    title1: 'Veuillez remplir vos informations pour obtenir des ressources',
    title2: 'Veuillez sélectionner les ressources que vous souhaitez télécharger',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Télécharger le rapport',
      downloadBtnText: 'Télécharger PDF',
      content: 'Contenu',
      theEnd: 'Fin',
      thankYouForWatching: 'Merci pour votre visionnage.',
      pdfProcessing: 'Traitement du PDF...',
      pdfProcessingDesc:
        'Pages PDF : {{count}}, attendu {{seconds}} secondes, enregistrer après, veuillez patienter',
      pdfProcessingDesc2:
        'La version actuelle du langue n’est pas traduite, ne peut pas générer PDF',
    },
    ppt: {
      downloadBtnText: 'Télécharger PPT',
      pptProcessingDesc: 'Génération du fichier PPT en cours, veuillez patienter',
      pptProcessingDesc2:
        "La version linguistique actuelle n'est pas traduite, impossible de générer le PPT",
      pptProcessingDesc3: 'Téléchargement du fichier PPT en cours, veuillez patienter...',
      translateCompleted: 'Traduction PPT terminée',
      exportSuccess: 'Exportation du fichier PPT réussie',
      exportFailed: "Échec de l'exportation du fichier PPT",
    },
    layout: {
      projectMenuText: 'Projets de test publicitaire',
      accountManagementText: 'Gestion de compte',
      myAccountText: 'Mon compte',
      subscriptionText: 'Abonnement',
      logout: 'Se déconnecter',
      dataDetails: 'Détails des données',
      dataAnalysis: 'Analyse des données',
      dataOverview: 'Vue d’ensemble des données',
      dataComparison: 'Comparaison des données',
    },
    systemMessage: {
      title: 'Message système',
      task: 'Tâche',
      system: 'Système',
      noRelevantContent: 'Aucun contenu pertinent trouvé',
      noMore: 'Plus de messages',
    },
    projectPage: {
      createProject: 'Créer un projet',
      searchPlaceholder: 'Entrez le nom du projet/publicité/marque pour rechercher',
      sortLabel: "Trier par indice d'efficacité publicitaire",
      sortPlaceholder: 'Veuillez choisir une méthode de tri',
      sortOption1: 'Ordre croissant de l’indice d’efficacité',
      sortOption2: 'Ordre décroissant de l’indice d’efficacité',
      filterSort: 'Filtrer et trier',
      filterBenchmarkTitle: 'Filtrer le benchmark',
      sortTitle: 'Trier',
      tabAllCreative: 'Toutes les créations ({{count}})',
      tabGeneralCreative: 'Créations régulières ({{count}})',
      tabSplashCreative: 'Créations splash ({{count}})',
      generalCreativeLabel: 'Création régulière',
      splashCreativeLabel: 'Création splash',
      normTypePlaceholder: 'Veuillez sélectionner le type de référence',
      totalDesc: 'Projets publicitaires (total de {{total}})',
      noRelevantContent: 'Aucun contenu pertinent trouvé',
      loadMore: 'Charger plus',
      projectCard: { delete: 'Supprimer', reanalyze: 'Réanalyser', download: 'Télécharger' },
      delete: 'Supprimer',
      cancel: 'Annuler',
      message: {
        deleteTitle: 'Alerte de suppression',
        delete:
          'Une fois ce projet supprimé, toutes les données associées deviendront inaccessibles. Êtes-vous sûr de vouloir continuer ?',
        delete1:
          'Ce projet est un projet de test gratuit, et la suppression ne retournera pas l’opportunité de test',
        delete2:
          "Ce projet n'a pas encore commencé l'analyse. Après suppression, vos crédits de test seront remboursés",
        deleteSuccess: 'Suppression réussie !',
        analysisCountNotEnough: 'Nombre de tests insuffisant, veuillez recharger et réessayer.',
        analysisFailed: 'Échec de l’analyse, veuillez réessayer plus tard.',
        waitingQuestion:
          "Maximum 3 projets peuvent être analysés simultanément. Ce projet est entré dans la file d'attente et commencera automatiquement l'analyse plus tard.",
        landscapeQuickCompleted: 'Votre projet de test rapide horizontal est terminé.',
        portraitQuickCompleted: 'Votre projet de test rapide vertical est terminé.',
        landscapeSurveyCompleted: 'Votre projet horizontal d’analyse approfondie est terminé.',
        portraitSurveyCompleted: 'Votre projet vertical d’analyse approfondie est terminé.',
      },
    },
    projectCreatePage: {
      createProject: 'Créer un projet',
      basicInformation: 'Informations de base',
      projectType: 'Type de projet',
      projectName: 'Nom du projet',
      categoryType: 'Industrie',
      brandName: 'Nom de la marque',
      advertisingInformation: 'Informations publicitaires',
      adName: 'Nom de la publicité',
      targetMarketNorm: 'Valeur de référence du marché cible',
      norm: 'Valeur de référence',
      brandNorm: 'Valeur de référence de la marque',
      taGender: 'Genre TA',
      targetMarket: 'Marché cible',
      taAge: 'Âge TA',
      next: 'Suivant',
      previous: 'Précédent',
      confirmOrder: 'Confirmer la commande',
      estTime: 'Temps estimé',
      minutes: 'minutes',
      consumption: 'Consommation de cette commande',
      testPoint: 'Nombre de tests',
      remaining: 'Restant',
      times: 'fois',
      type: 'Type',
      purchase: 'Acheter',
      outputLanguage: 'Langue de sortie',
      durationCategory: 'Type de création',
      durationCategoryDesc: 'Les métriques d’analyse varient selon le type de création. Veuillez sélectionner l’option la plus adaptée à votre contenu.',
      durationCategoryOptions: {
        tenPlus: 'Création générale (10s+)',
        fiveToTen: 'Création d’ouverture (5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Test créatif publicitaire',
        adCreativeTestDesc:
          'Tester le feedback de l’audience sur un seul créatif publicitaire, fournir des analyses et des suggestions',
        adCreativeSelection: 'Sélection créative publicitaire',
        adCreativeSelectionDesc:
          'Comparer les effets de feedback de plusieurs créatifs publicitaires, choisir de manière globale',
        adCreativeEditing: 'Édition créative publicitaire',
        adCreativeEditingDesc:
          'L’IA filtre automatiquement les parties essentielles des créatifs publicitaires',
        launchingSoon: 'Lancement prochain',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Alimentation et boissons',
        packagedFood: 'Alimentation préemballée',
        confectionery: 'Confiture',
        frozenMeals: 'Plats surgelés',
        fastFood: 'Fast Food',
        beverage: 'Boissons',
        alcohol: 'Alcool',
        dairy: 'Lait',
        grainAndSeasoning: 'Céréales et épices',
        beverageMixes: 'Boissons préparées',
        freshProduce: 'Fruits frais',
        otherFoodAndBeverage: 'Autres aliments et boissons',
        /**----------------------- */
        consumerElectronicsCategory: 'Électronique de consommation',
        mobilePhone: 'Téléphone mobile',
        computer: 'Ordinateur',
        smartDevice: 'Appareil intelligent',
        phoneAccessories: 'Accessoires de téléphone',
        computerAccessories: 'Accessoires d’ordinateur',
        software: 'Logiciel',
        camera: 'Appareil photo',
        officeSupplies: 'Fournitures de bureau',
        otherConsumerElectronics: 'Autres électroniques de consommation',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Pharmaceutiques et soins de santé',
        otcMedicine: 'Médicaments OTC',
        prescriptionDrugs: 'Médicaments de prescription',
        healthSupplements: 'Suppléments de santé',
        pharmaceuticalCompanies: 'Entreprises pharmaceutiques',
        medicalDevices: 'Appareils médicaux',
        medicalServices: 'Services médicaux',
        pharmacy: 'Pharmacie',
        otherPharmaceuticalsAndHealthCare: 'Autres pharmaceutiques et soins de santé',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Beauté et soins personnels',
        hairCare: 'Soins capillaires',
        womenSkincare: 'Soins pour les femmes',
        homeCleaning: 'Nettoyage du domicile',
        bodyCare: 'Soins corporels',
        feminineCare: 'Soins pour les femmes',
        oralCare: 'Soins dentaires',
        menSkincare: 'Soins pour les hommes',
        makeup: 'Maillage',
        fragrances: 'Parfums',
        beautyServices: 'Services de beauté',
        otherBeautyAndPersonalCare: 'Autres soins personnels',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Produits maternels et infantiles',
        babyFood: 'Alimentation pour bébés',
        babyCareEssentials: 'Essentiels pour les bébés',
        babyToys: 'Jouets pour bébés',
        otherMaternalAndInfantProducts: 'Autres produits maternels et infantiles',
        /**----------------------- */
        networkAndCommunicationCategory: 'Réseau et télécommunications',
        mobileCarriers: 'Opérateurs de téléphonie mobile',
        internetProviders: 'Fournisseurs d’accès à Internet',
        telecomEquipment: 'Équipements de télécommunications',
        otherNetworkAndCommunication: 'Autres réseaux et télécommunications',
        /**----------------------- */
        travelAndAccommodationCategory: 'Voyage et hébergement',
        localTourism: 'Tourisme local',
        bookingPlatform: 'Plateforme de réservation',
        hotels: 'Hôtels',
        airlines: 'Compagnies aériennes',
        airport: 'Aéroports',
        otherTravelAndAccommodation: 'Autres voyages et hébergement',
        /**----------------------- */
        vehiclesCategory: 'Véhicules',
        motorVehicleProductsAndServices: 'Produits et services de véhicules',
        carBrands: 'Marques de voitures',
        dealerships: 'Concessionnaires',
        carFinance: 'Financement automobile',
        evCar: 'Véhicules électriques',
        motorcycle: 'Motos',
        onlineUsedCarMarketplace: 'Marché automobile en ligne',
        carRentalPlatform: 'Plateforme de location de véhicules',
        travelNavigation: 'Navigation de voyage',
        bicycle: 'Vélo',
        otherVehicles: 'Autres véhicules',
        /**----------------------- */
        householdAppliancesCategory: 'Appareils ménagers',
        majorAppliances: 'Grandes électroménagers',
        healthAndPersonalCareAppliances: 'Appareils de soins personnels',
        majorKitchenAndBathAppliances: 'Grandes électroménagers',
        smallKitchenAppliances: 'Petits électroménagers',
        environmentalAppliances: 'Appareils de nettoyage',
        cleaningAppliances: 'Appareils de nettoyage',
        otherHouseholdAppliances: 'Autres appareils ménagers',
        /**----------------------- */
        retailAndServiceCategory: 'Commerce et services',
        onlineRetailEcommerce: 'Commerce en ligne',
        departmentStores: 'Magasins de détail',
        lifeServices: 'Services de vie',
        retailServicesAndDelivery: 'Services de vente/Livraison',
        supermarkets: 'Supermarchés',
        otherRetailAndService: 'Autres services de commerce et vente',
        /**----------------------- */
        apparelCategory: 'Vêtements et accessoires',
        footwear: 'Chaussures',
        clothing: 'Vêtements',
        watchesWatchRetail: 'Montres/Bijoux',
        jewelry: 'Bijoux',
        bags: 'Sac',
        eyewearOpticalStores: 'Lunettes/Opticiens',
        otherClothingAndAccessories: 'Autres vêtements et accessoires',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Aménagement et décoration',
        homeFurnishing: 'Décoration',
        homeImprovement: 'Aménagement',
        otherHomeImprovementAndFurnishings: 'Autres aménagements et décorations',
        /**----------------------- */
        financialAndInsuranceCategory: 'Finance et assurance',
        bank: 'Banque',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Investissement et services financiers',
        insurance: 'Assurance',
        otherFinancialAndInsurance: 'Autres finance et assurance',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Loisirs et divertissement',
        socialApp: 'Application sociale',
        toysAndDolls: 'Jouets et poupées',
        concerts: 'Concerts',
        events: 'Événements',
        movies: 'Films',
        themeParks: 'Parcs thématiques',
        gambling: 'Jeux de hasard',
        onlineGaming: 'Jeux en ligne',
        tvChannels: 'Chaînes de télévision',
        otherEntertainmentAndLeisure: 'Autres loisirs et divertissement',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Industrie et agriculture',
        industrialSupplies: 'Fournitures industrielles',
        agriculturalSupplies: 'Fournitures agricoles',
        otherIndustrialAndAgricultural: 'Autres industries et agricultures',
        /**----------------------- */
        petLifeCategory: 'Vie animale',
        petFood: 'Aliments pour animaux',
        petSupplies: 'Fournitures pour animaux',
        otherPetLife: 'Autres fournitures pour animaux',
        /**----------------------- */
        educationAndLearningCategory: 'Éducation et apprentissage',
        onlineLearning: 'Apprentissage en ligne',
        schools: 'Écoles',
        skillCourses: 'Cours de compétences',
        tutoring: 'Tutorat',
        universities: 'Universités',
        otherEducationAndLearning: 'Autres produits d’éducation et d’apprentissage',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Communauté et services publics',
        charityCampaigns: 'Campagnes de charité',
        ngoAds: 'Annonces d’ONG',
        otherCommunityAndPublicService: 'Autres services de communauté et publics',
        /**----------------------- */
        otherCategory: 'Autre',
        governmentAdvertising: 'Publicité gouvernementale',
        realEstateAdvertising: 'Publicité immobilière',
        otherAdvertising: 'Autres publicités',
      },
      genderSelect: {
        male: 'Homme',
        female: 'Femme',
        all: 'Tous',
      },
      targetMarketSelect: {
        China: 'Chine',
        HongKongChina: 'Hong Kong, Chine',
        MacauChina: 'Macao, Chine',
        TaiwanChina: 'Taïwan, Chine',
        Japan: 'Japon',
        Korea: 'Corée',
        Mongolia: 'Mongolie',
        Singapore: 'Singapour',
        Thailand: 'Thaïlande',
        Vietnam: 'Vietnam',
        Malaysia: 'Malaisie',
        Philippines: 'Philippines',
        Indonesia: 'Indonésie',
        Cambodia: 'Cambodge',
        Laos: 'Laos',
        India: 'Inde',
        SaudiArabia: 'Arabie saoudite',
        Turkey: 'Turquie',
        Israel: 'Israël',
        UnitedArabEmirates: 'Émirats Arabes Unis',
        Qatar: 'Qatar',
        Kuwait: 'Koweït',
        UnitedKingdom: 'Royaume-Uni',
        France: 'France',
        Germany: 'Allemagne',
        Netherlands: 'Pays-Bas',
        Belgium: 'Belgique',
        Austria: 'Autriche',
        Italy: 'Italie',
        Spain: 'Espagne',
        Portugal: 'Portugal',
        Greece: 'Grèce',
        Sweden: 'Suède',
        Norway: 'Norvège',
        Finland: 'Finlande',
        Denmark: 'Danemark',
        Estonia: 'Estonie',
        Latvia: 'Lettonie',
        Russia: 'Russie',
        Poland: 'Pologne',
        CzechRepublic: 'République tchèque',
        Hungary: 'Hongrie',
        Romania: 'Roumanie',
        Bulgaria: 'Bulgarie',
        Slovakia: 'Slovaquie',
        Slovenia: 'Slovénie',
        Ukraine: 'Ukraine',
        UnitedStates: 'États-Unis',
        Canada: 'Canada',
        Mexico: 'Mexique',
        Brazil: 'Brésil',
        LatinAmerica: 'Amérique latine',
        Australia: 'Australie',
        NewZealand: 'Nouvelle-Zélande',
        Other: 'Autre',
      },
      languageSelect: {
        english: 'Anglais',
        chinese: 'Chinois',
        japanese: 'Japonais',
        korean: 'Coréen',
        french: 'Français',
        traditionalChinese: 'Chinois traditionnel',
      },
      placeholder: {
        projectName: 'Entrez le nom du projet',
        category: 'Sélectionnez une catégorie',
        brandName: 'Entrez le nom de la marque',
        adName: 'Entrez le nom de la publicité',
        norm: 'Veuillez sélectionner la valeur de référence',
        taGender: 'Sélectionnez le sexe',
        targetMarket: 'Sélectionnez le marché cible',
        taAge: 'Sélectionnez l’âge',
        lowerLimit: 'Limite inférieure',
        upperLimit: 'Limite supérieure',
        outputLanguage: 'Veuillez sélectionner la langue de sortie',
      },
      step: {
        step1: 'Saisie des informations du projet',
        step2: 'Confirmation des informations de commande',
      },
      message: {
        success: 'Création réussie',
        videoDurationOver60s: 'La durée de la vidéo dépasse {{max}} secondes',
        videoDurationLessThan10s: 'La durée de la vidéo est inférieure à {{min}} secondes',
        videoDurationNeedOver10s: 'La durée de la vidéo doit dépasser 10 s',
        videoDurationNeedWithin5To10s: 'La durée de la vidéo doit être comprise entre 5 s et 10 s',
        videoDurationNotMatchDurationCategory: 'La durée actuelle de la vidéo ne correspond pas à ce type de projet. Veuillez téléverser à nouveau la vidéo puis réessayer.',
        videoUploadingCannotSwitchDurationCategory: 'Vous ne pouvez pas changer de type de création pendant le téléversement de la vidéo. Veuillez attendre la fin du téléversement.',
        videoFormatOrDurationError: 'Impossible de lire le format ou la durée de la vidéo. Veuillez vérifier le fichier vidéo et réessayer.',
        videoSizeOver200M: 'La taille de la vidéo dépasse 256 Mo',
        videoLandscape: 'La vidéo doit être en format horizontal',
        videoPortrait: 'La vidéo doit être au format portrait',
        clickToUploadTestVideo: 'Cliquez pour télécharger la vidéo de test',
        uploadFailed: 'Échec du téléchargement, veuillez réessayer',
        uploadDesc1: 'Prend en charge les fichiers vidéo en MP4, MOV',
        uploadDescPortrait: 'Prend en charge les vidéos portrait aux formats MP4, MOV',
        uploadDesc2: "d'autres formats, avec une taille de fichier limitée à 256 Mo",
        formNotCompleted: 'Veuillez remplir toutes les informations',
        uploadAdVideo: 'Veuillez télécharger la vidéo publicitaire',
        inputInvalid: 'Le contenu saisi est invalide',
        insufficientTestPoints: 'Points de test insuffisants, veuillez recharger et réessayer.',
        reviewProjectInfo:
          'Veuillez vérifier attentivement les informations de votre projet. Une fois la commande confirmée, elle ne pourra plus être modifiée.',
        waitingDesc:
          'Jusqu’à 3 projets peuvent être analysés simultanément. Les projets supplémentaires entreront dans la file d’attente et seront traités séquentiellement par le système.',
        ageRangeInvalid: 'La plage d’âge ne prend en charge que 20-55',
        normDesc:
          'Avantages illimités de droits d’auteur, valeur de référence personnalisée par l’entreprise',
      },
    },
    projectDetailPage: {
      testResults: 'Résultats des tests',
      share: 'Partager',
      shareFailed: 'Échec du partage',
      shareModal: {
        title: 'Partager',
        desc: 'Copiez le texte ci-dessous et partagez-le sur les réseaux sociaux.',
        saveImage: 'Enregistrer l’image',
        copyText: 'Copier le texte',
        copySuccess: 'Copié',
        copyFailed: 'Échec de la copie',
        textTemplate:
          "Waouh ! Ma création IA a dépassé {{score}} % des créations similaires sur AdEff ! Les données, c'est ce qui compte vraiment. Le test de créations IA d'AdEff est gratuit en ce moment. Vérifiez votre score sur {{hostname}}. Obtenez 5 tests gratuits, et nous vous souhaitons d'excellentes évaluations !",
      },
      sharePoster: {
        createdByYou: 'Créé par vous',
        scoreTemplate: 'A dépassé <score>{{score}}</score> des créations AIGC',
        statsAt: 'Statistiques du ',
        certification: 'Certification de créativité',
        footerText:
          'Nous espérons que vous continuerez à créer et à proposer davantage d’œuvres de qualité !',
      },
      basicInformation: 'Informations de base',
      waiting: 'En attente',
      ongoing: 'En cours',
      failed: 'Échoué',
      tryAgain: 'Réessayer',
      videoAnalysisFailed: 'Échec de l’analyse vidéo',
      message: { projectNotFound: 'Projet introuvable' },
      primaryAnalysis: 'Performance clé',
      detailAnalysis: 'Analyse détaillée',
      heatmapAnalysis: 'Carte thermique',
      analysisStepDesc:
        'L’IA a terminé toutes les tâches d’analyse, l’analyse détaillée est la suivante',
      analysisWaitingDesc:
        'Jusqu’à 3 projets peuvent être analysés simultanément. Les projets supplémentaires entreront dans la file d’attente et seront traités séquentiellement par le système.',
      aiTip: 'Le contenu du rapport est généré par IA et est uniquement à des fins de référence',
      subAnalysisDescription: {
        adVideoScore: 'Indice d’efficacité publicitaire',
        adVideoScoreDesc:
          'L’indice d’efficacité publicitaire est un indicateur intégral de l’efficacité de la publicité, capable de prédire les effets à court et long terme des publicités.',
        norm: 'Valeur de référence',
        normDesc:
          'Valeur de référence basée sur des données sectorielles ou historiques, utilisée pour comparer les performances publicitaires.',
        attentionIndex: 'Indice d’attention',
        attentionIndexDesc:
          'Réflecte la concentration de l’attention visuelle de l’audience, indiquant la capacité des scènes et des éléments publicitaires à attirer le regard.',
        emotionIndex: 'Indice émotionnel',
        emotionIndexDesc:
          'Réflecte le degré d’activation des émotions positives de l’audience, indiquant les fluctuations émotionnelles instantanées provoquées par la publicité.',
        cognitionIndex: 'Indice cognitif',
        cognitionIndexDesc:
          'Réflecte le degré de traitement cognitif de l’audience, c’est-à-dire dans quelle mesure elle a réfléchi au contenu publicitaire.',
        theGolden3Seconds: 'Les 3 secondes d’or',
        theGolden3SecondsDesc:
          'Les 3 premières secondes de la publicité sont un moment clé pour déterminer le succès de la publicité.',
        informationTransmission: 'Moment d’information',
        informationTransmissionDesc:
          'Mesure la capacité du moment d’information publicitaire à capter l’attention de l’audience cible et à susciter l’intérêt.',
        brandRelevance: 'Moment de marque',
        brandRelevanceDesc:
          'Mesure la capacité du moment de marque à capter l’attention de l’audience cible et à susciter l’intérêt.',
        interestStimulation: 'Moment d’intérêt',
        interestStimulationDesc:
          'Moment clé du contenu qui suscite la résonance émotionnelle et la cognition active de l’audience.',
        theEnding3Seconds: 'Les 3 dernières secondes',
        theEnding3SecondsDesc:
          'Basé sur la loi du pic et de la fin, les 3 dernières secondes de la publicité sont un moment clé pour renforcer l’attention des spectateurs et améliorer la transmission d’informations.',
      },
      infoDrawer: {
        basicInformation: 'Informations de base',
        advertisingInformation: 'Informations publicitaires',
        projectName: 'Nom du projet',
        brandName: 'Nom de la marque',
        category: 'Industrie',
        norm: 'Norme du marché cible',
        normLabel: 'Norme',
        brandNorm: 'Norme de la marque',
        adName: 'Nom de la publicité',
        taGender: 'Genre TA',
        targetMarket: 'Marché cible',
        taAge: 'Âge TA',
        ageRange: '{{start}} à {{end}} ans',
        modify: 'Modifier',
        cancel: 'Annuler',
        confirm: 'Confirmer',
      },
      videoView: {
        eyeMovementRatio: 'Indice d’attention',
        cognitiveEngagement: 'Indice cognitif',
        emotionRecognition: 'Indice émotionnel',
        subjectiveResponseCurve: 'Courbe de réponse subjective',
        realtimeData: 'Données en temps réel',
        panoramicData: 'Données panoramiques',
        indexAnalysis: 'Analyse des indices',
        advantage: 'Avantage',
        disadvantage: 'Inconvénient',
        suggestions: 'Suggestions',
        adVideoScore: 'Indice d’efficacité publicitaire',
        norm: 'Valeur de référence',
        analysisStepTitle1: 'Décodage de contenu',
        analysisStepTitle2: 'Prévision de feedback',
        analysisStepTitle3: 'Intégration de données',
        analysisStepTitle4: 'Raisonnement des conclusions',
        analysisStepDesc1:
          'Commencez le décodage multimodal du contenu publicitaire, décodez la vision, le son, le texte et la structure...',
        analysisStepDesc2:
          'Commencez à prédire les réactions subjectives de l’audience, en prédisant les données de regard et d’EEG basées sur le contenu publicitaire par seconde...',
        analysisStepDesc3:
          'Commencez à intégrer le contenu objectif de la publicité et les données de réaction subjective de l’audience...',
        analysisStepDesc4:
          'Commencez à générer des conclusions d’évaluation et des recommandations d’action basées sur le modèle de raisonnement...',
        keyResult: 'Résultat clé',
        videoChart: {
          videoFailed: 'Échec de la lecture vidéo',
          videoFailedAction:
            'Veuillez actualiser et réessayer. Si le problème persiste après plusieurs actualisations, veuillez nous contacter pour obtenir de l’aide.',
        },
      },
      storyboardView: {
        summary: 'Résumé',
        advantages: 'Avantages',
        disadvantages: 'Inconvénients',
        suggestions: 'Suggestions',
        keyResult: 'Résultat clé',
        norm: 'Valeur de référence',
        theGolden3Seconds: 'Les 3 secondes d’or',
        informationTransmission: 'Moment d’information',
        brandRelevance: 'Moment de marque',
        interestStimulation: 'Moment d’intérêt',
        theEnding3Seconds: 'Les 3 dernières secondes',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'E-mail',
      username: 'Nom d’utilisateur',
      password: 'Mot de passe',
      setPasswordToEnableEmailLogin:
        'Définissez un mot de passe pour activer la connexion par e-mail',
      uid: 'UID',
      contactAndReceiveNotifications: 'Contactez et recevez des notifications',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Recevez des e-mails concernant les dernières mises à jour d’AdEff à cette adresse e-mail.',
      myWorkspace: 'Mon espace de travail',
      newRequest: 'Nouvelle demande',
      invitationCode: 'Code de parrainage',
      userName: 'Nom d’utilisateur',
      invitationCodeDesc:
        'Chaque équipe a un code d’invitation unique pour que les nouveaux utilisateurs demandent à rejoindre l’équipe lors de l’inscription',
      table: {
        userName: 'Nom d’utilisateur',
        email: 'E-mail',
        operation: 'Opération',
        admin: 'Administrateur',
        remove: 'Supprimer',
        deny: 'Refuser',
        approve: 'Approuver',
      },
      message: {
        yourTeamIsFull:
          'Votre équipe est pleine. Vous pouvez nous contacter pour obtenir plus de membres ou supprimer d’autres membres.',
        invitationLinkSent: 'Le lien d’invitation a été envoyé à cette adresse e-mail !',
        removeReminder: 'Alerte de suppression',
        remove: 'Supprimer',
        removeMember:
          'La suppression d’un membre conservera le contenu créé par ce membre. Voulez-vous vraiment supprimer ce membre ?',
        removeMemberSuccess: 'Suppression du membre réussie !',
        ok: 'D’accord',
        contactUs: 'Contactez-nous',
        applicationProcessedSuccessfully: 'Demande traitée avec succès !',
        notificationSettingsTurnedOn: 'Paramètres de notification activés',
        notificationSettingsTurnedOff: 'Paramètres de notification désactivés',
        setPassword: 'Définir le mot de passe',
        passwordConfirm: 'Confirmer',
        passwordCancel: 'Annuler',
        oldPassword: 'Ancien mot de passe',
        newPassword: 'Nouveau mot de passe',
        pleaseEnterTheOldPassword: 'Veuillez entrer l’ancien mot de passe',
        pleaseEnterTheNewPassword: 'Veuillez entrer le nouveau mot de passe',
        incorrectEntryOfOriginalPassword: 'Erreur dans la saisie de l’ancien mot de passe',
        passwordUpdatedSuccessfully: 'Mot de passe mis à jour avec succès',
        changeUsername: 'Changer le nom d’utilisateur',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        username: 'Nom d’utilisateur',
        pleaseEnterTheNewUsername: 'Veuillez entrer un nouveau nom d’utilisateur',
        userNameUpdatedSuccessfully: 'Nom d’utilisateur mis à jour avec succès',
        addMemberToWorkspace: 'Ajouter un nouveau membre à l’espace de travail',
        notAdminOperate: 'Non administrateur, ne peut pas opérer',
        emailAddress: 'Adresse e-mail',
        send: 'Envoyer',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Nous enverrons un e-mail d’invitation à cette adresse pour confirmation.',
        workspaceMemberShip: 'Adhésion à l’espace de travail',
        forMoreMembership: 'Plus d’adhésion',
        reachedTheCeiling: 'Le nombre de membres a atteint la limite.',
        incorrectMailboxFormat: 'Format de boîte aux lettres incorrect',
        member: 'Membre',
        changeCorpNameTitle: 'Changer le nom de la société',
        changeCorpNameLabel: 'Nom de la société',
        pleaseEnterTheCorpName: 'Veuillez entrer le nom de la société',
        changeCorpNameSuccess: 'Nom de la société changé avec succès',
        changeCorpNameFailed: 'Changement de nom de la société échoué',
        noPermission: 'Vous n’avez pas la permission de changer le nom de la société',
      },
    },
    subscriptionPage: {
      currentPlan: 'Plan actuel',
      getInvoice: 'Obtenir votre facture',
      remainingTimes: 'Nombre de fois restantes',
      purchaseMore: 'Acheter plus',
      contactUs: 'Contactez-nous',
      teamPlan: 'Service d’équipe d’experts',
      unlimited: 'Illimité',
      dueDate: 'Date d’expiration',
      table: {
        usageRecords: 'Dossiers d’utilisation',
        date: 'Date',
        projectName: 'Nom du projet',
        projectType: 'Type de projet',
        usageCount: 'fois',
        userName: 'Nom d’utilisateur',
        noRelevantContent: 'Aucun contenu pertinent trouvé',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Projet de création régulière',
      regularCreative: 'Création régulière',
      splashCreativeProject: 'Projet de création splash',
      splashCreative: 'Création splash',
      projects: 'Projets',
      localNorm: 'Valeur de référence locale',
      projectPassRate: 'Taux de réussite du projet',
      passRate: 'Taux de réussite',
    },
    dataDetailPage: {
      baseData: 'Données de base',
      totalProjects: 'Nombre total de projets',
      totalProjectsDesc:
        'Nombre total de projets valides participant à l’évaluation de l’efficacité publicitaire.',
      // averageEffectivenessIndex: 'Indice moyen d’efficacité',
      // averageEffectivenessIndexDesc:
      // 'La moyenne de l’indice d’efficacité publicitaire de tous les projets valides.',
      localNormProjects: 'Projets de référence locaux',
      brandNormProjects: 'Projets de référence de la marque',
      normProject: 'Projet de référence du marché cible',
      brandNormProject: 'Projet de référence de la marque',
      localNorm: 'Valeur de référence locale',
      localNormDesc:
        'La moyenne de l’indice d’efficacité publicitaire des projets valides ayant pour cible votre pays.',
      norm: 'Valeur de référence',
      brandNorm: 'Valeur de référence de la marque',
      brandNormDesc:
        'La moyenne de l’indice d’efficacité publicitaire des projets valides ayant pour cible la valeur de référence de la marque.',
      localProjectPassRate: 'Taux de réussite des projets locaux',
      projectPassRate: 'Taux de réussite des projets',
      brandProjectPassRate: 'Taux de réussite des projets de la marque',
      projectPassRateDesc:
        'Proportion de projets dont l’indice d’efficacité publicitaire dépasse la valeur de référence par rapport au total des projets évalués.',
      advertisingEffectivenessIndexDistribution:
        'Distribution de l’indice d’efficacité publicitaire',
      advertisingEffectivenessIndexDistributionDesc:
        'Proportion de projets dans différentes plages de l’indice d’efficacité publicitaire.',
      item: 'éléments',
    },
    dataComparisonPage: {
      createCompare: 'Nouvelle comparaison',
      createCompareDesc: 'Sélectionnez plusieurs projets à comparer, jusqu’à 10 projets.',
      startCompare: 'Démarrer la comparaison',
      compareReport: 'Rapports de comparaison',
      searchPlaceholder: 'Rechercher le nom du rapport de comparaison',
      emptyText: 'Aucun rapport de comparaison pour le moment. Sélectionnez d’abord des projets à comparer.',
      searchEmptyText: 'Aucun rapport de comparaison trouvé.',
      deleteTitle: 'Supprimer le rapport de comparaison',
      deleteConfirm: 'Voulez-vous vraiment supprimer ce rapport de comparaison ? Cette action est irréversible.',
      projectCount: '{{count}} projets',
    },
    dataComparisonStartPage: {
      back: 'Retour',
      basicInfo: 'Informations de base',
      reportName: 'Nom du rapport :',
      reportNamePlaceholder: 'Saisissez le nom du rapport de comparaison',
      norm: 'Référence :',
      normPlaceholder: 'Sélectionner la référence',
      normTip: 'Sélectionnez la référence utilisée pour comparer les projets',
      selectProject: 'Sélectionner des projets',
      searchPlaceholder: 'Rechercher par projet/publicité/marque',
      selectedCountPrefix: ' Sélectionnés ',
      selectedCountSuffix: ' projets, jusqu’à {{max}} projets',
      startCompare: 'Démarrer la comparaison',
      save: 'Enregistrer',
      cancel: 'Annuler',
      maxSelectedWarning: 'Vous pouvez sélectionner jusqu’à 10 projets',
      reportNameRequired: 'Saisissez le nom du rapport de comparaison',
      normRequired: 'Sélectionnez la référence',
      projectRequired: 'Sélectionnez des projets',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Nom du rapport de comparaison',
      reportNotFound: 'Rapport introuvable',
      back: 'Retour',
      modify: 'Modifier',
      deletedProjectTip: 'Les projets suivants : {{names}} ont été supprimés. Après confirmation, le rapport de comparaison sera mis à jour et les projets supprimés seront retirés.',
      confirmDeletedProjects: 'Confirmer',
      metricScore: 'Score de l’indicateur',
      tabDimension: 'Cinq dimensions',
      tabMoment: 'Moment clé',
      tabAttitude: 'Attitude du consommateur',
      adeffScore: 'Score AdEff',
      brandName: 'Nom de la marque',
      projectName: 'Nom du projet',
      industry: 'Secteur',
      targetMarket: 'Marché cible',
      gender: 'Genre du TA',
      age: 'Âge du TA',
      adProject: 'Projet publicitaire',
      normLabel: 'Référence',
      mixedCreativeBenchmarkTip: 'Aucune référence n’est disponible lors de la comparaison simultanée de créations générales et de créations splash.',
      emptyProject: 'Sélectionnez des projets pour afficher les données de comparaison',
      viewProjectDetail: 'Voir les détails du projet',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Force d’attention',
        infectivity: 'Force émotionnelle',
        delivery: 'Force du message',
        brand: 'Force de marque',
        persuasion: 'Force persuasive',
        gazeRecognition: 'Reconnaissance du regard',
        emotionRecognition: 'Reconnaissance des émotions',
        engagementRecognition: 'Reconnaissance de l’engagement',
        goldenSeconds: 'Les 3 secondes d’or',
        brandMoment: 'Moment de marque',
        productMoment: 'Moment d’intérêt',
        messageMoment: 'Moment d’information',
        endingSeconds: 'Les 3 dernières secondes',
        likeability: 'Appréciation',
        newInformation: 'Nouvelle information',
        messageRelevance: 'Pertinence du message',
        comprehension: 'Compréhension',
        credibility: 'Crédibilité',
        brandLinkage: 'Lien avec la marque',
        uniqueness: 'Unicité',
        learnMoreIntent: 'Volonté d’en savoir plus',
        purchaseIntent: 'Intention d’achat',
        recommendIntent: 'Partageabilité',
        brandLikeabilityLift: 'Hausse d’appréciation de la marque',
        purchaseIntentionLift: 'Hausse de l’intention d’achat',
        attentionIndex: 'Indice d’attention',
        emotionIndex: 'Indice émotionnel',
        cognitionIndex: 'Indice cognitif',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Votre projet d’évaluation créative TVC est terminé.',
        title: {
          text1: 'Test de créativité publicitaire',
          text2: 'Rapport de test',
        },
        flowAnalysis: {
          desc1: 'AdEff décompose votre vidéo publicitaire',
          desc2: 'Décomposition de la vidéo terminée',
          desc3: 'Analyse de l’attention visuelle des consommateurs',
          desc4: 'Analyse du foyer visuel selon les profils consommateurs',
          desc5: 'Génération de la carte thermique d’attention',
          desc6: 'Carte thermique dynamique générée',
          desc7: 'Mesure des réponses cognitivo-neuronales',
          desc8: 'Suivi du regard, de l’émotion et de l’engagement seconde par seconde',
          desc9: 'Génération de la courbe de réponse neuronale',
          desc10: 'Courbe de réponse neuronale générée',
          desc11: 'Analyse des performances aux moments clés',
          desc12: 'Mesure des réponses cognitivo-neuronales pendant : 3 secondes d’or, moment du message, moment de marque, pic d’intérêt et 3 dernières secondes',
          desc13: 'Synthèse des métriques des moments clés',
          desc14: 'Analyse des moments clés terminée',
          desc15: 'Analyse des attitudes des consommateurs',
          desc16: 'Analyse des attitudes envers la marque, le produit et le contenu',
          desc17: 'Synthèse des métriques d’attitude',
          desc18: 'Métriques d’attitude terminées',
          desc19: 'Génération des scores des cinq leviers',
          desc20: 'Scores des cinq leviers prêts',
          desc21: 'Analyse terminée ! Votre rapport de performance publicitaire est prêt',
          terminology: {
            thumbExpand: 'Développer les miniatures',
            thumbCollapse: 'Réduire les miniatures',
            gazeRecognition: 'Reconnaissance du regard',
            gazeRecognitionDesc: 'Mesure la concentration de l’attention visuelle et indique l’efficacité avec laquelle les éléments publicitaires captent le regard.',
            emotionRecognition: 'Reconnaissance des émotions',
            emotionRecognitionDesc: 'Quantifie les émotions positives et les réponses affectives immédiates déclenchées par la publicité.',
            engagementRecognition: 'Reconnaissance de l’engagement',
            engagementRecognitionDesc: 'Mesure l’immersion et l’engagement, reflétant l’investissement mental dans le contenu publicitaire.',
            theGolden3Seconds: 'Performance des 3 secondes d’or',
            theGolden3SecondsDesc: 'Évalue l’efficacité du contenu publicitaire pendant les 3 premières secondes.',
            keyMessage: 'Performance du message clé',
            keyMessageDesc: 'Mesure la capacité des moments d’information publicitaire à capter l’attention et stimuler l’intérêt.',
            brand: 'Performance de marque',
            brandDesc: 'Évalue la captation d’attention propre à la marque et l’efficacité de l’engagement.',
            interest: 'Pic d’intérêt',
            interestDesc: 'Identifie les pics de contenu qui déclenchent une résonance émotionnelle et un fort engagement.',
            ending3Seconds: 'Performance des 3 dernières secondes',
            ending3SecondsDesc: 'Évalue l’efficacité du contenu publicitaire pendant les 3 dernières secondes.',
            score: 'Score',
            benchmark: 'Référence',
            metrics: 'Métriques',
            attitudePart: {
              attitudeMetrics: 'Métriques d’attitude',
              liking: 'Appréciation',
              likingDesc: 'Mesure l’attitude subjective du public et son niveau global d’appréciation envers la publicité.',
              newInformation: 'Nouvelle information',
              newInformationDesc: 'Mesure si le public estime avoir obtenu grâce à la publicité des informations utiles et auparavant inconnues sur la marque ou le produit.',
              messageRelevance: 'Pertinence du message',
              messageRelevanceDesc: 'Mesure dans quelle mesure le public perçoit les informations transmises comme directement liées à lui.',
              comprehension: 'Compréhension',
              comprehensionDesc: 'Mesure si le message clé de la publicité a été compris clairement, précisément et sans effort.',
              credibility: 'Crédibilité',
              credibilityDesc: 'Mesure dans quelle mesure le public croit que les informations transmises sont vraies, fiables et dignes de confiance.',
              brandLinkage: 'Lien avec la marque',
              brandLinkageDesc: 'Mesure la capacité du public à associer correctement et fortement la publicité à la marque spécifique.',
              uniqueness: 'Unicité',
              uniquenessDesc: 'Mesure si la publicité établit clairement que la marque possède une singularité distinctive et précieuse face aux concurrents.',
              willing: 'Volonté d’en savoir plus',
              willingDesc: 'Mesure la probabilité subjective que le public cherche activement à en savoir plus sur la marque ou le produit après avoir vu la publicité.',
              purchase: 'Intention d’achat',
              purchaseDesc: 'Mesure la probabilité subjective que le public envisage de choisir ou d’acheter le produit de la marque à l’avenir.',
              share: 'Partageabilité',
              shareDesc: 'Mesure la probabilité subjective que le public partage activement la publicité ou les informations de marque avec d’autres personnes.',
              brandLikeLift: 'Hausse d’appréciation de la marque',
              brandLikeLiftDesc: 'Mesure la direction et l’ampleur du changement d’appréciation globale envers la marque ou le produit après exposition à la publicité.',
              purchaseIntentLift: 'Hausse de l’intention d’achat',
              purchaseIntentLiftDesc: 'Mesure la direction et l’ampleur du changement dans la volonté d’envisager l’achat du produit de la marque après exposition à la publicité.',
            },
            dimensionPart: {
              forceDrives: 'Leviers de force',
              attension: 'Attention',
              emotionalImpact: 'Impact émotionnel',
              messageClarity: 'Clarté du message',
              brandPower: 'Puissance de marque',
              persuasion: 'Persuasion',
              attentionForce: 'Force d’attention',
              attentionForceDesc: 'Mesure la capacité de la publicité à capter et maintenir l’attention visuelle et auditive du public.',
              emotionalForce: 'Force émotionnelle',
              emotionalForceDesc: 'Mesure l’intensité de la résonance émotionnelle immédiate et instinctive provoquée par le contenu publicitaire.',
              messageForce: 'Force du message',
              messageForceDesc: 'Mesure l’efficacité avec laquelle le message central de la publicité est clairement identifié, compris et mémorisé par la cible.',
              brandForce: 'Force de marque',
              brandForceDesc: 'Mesure l’efficacité de la publicité pour renforcer l’identité de marque, améliorer la préférence et construire un lien fort avec la marque.',
              persuasiveForce: 'Force persuasive',
              persuasiveForceDesc: 'Mesure la capacité finale de la publicité à modifier les perceptions et à stimuler les intentions comportementales.',
            },
            result: {
              results: 'Résultats',
              pass: 'Réussi',
              notPass: 'Non réussi',
              adeffScore: 'Score AdEff',
              adeffScoreDesc: 'Le score AdEff mesure l’efficacité globale des publicités.',
              benchmarkDesc: 'Le score AdEff moyen de toutes les publicités téléversées dans le pays ou la région de l’annonce sert à comparer sa performance.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'En attente...',
            description: 'Génération de votre rapport de test...',
          },
          generating: 'Génération...',
          freeTrialLockText1:
            'En mode essai, vous ne pouvez pas prévisualiser ni télécharger le rapport complet.',
          freeTrialLockText2: 'Souscrivez pour le débloquer.',
        },
      },
    },
  },
  professor: {
    account: 'Compte',
    password: 'Mot de passe',
    login: 'Connexion',
    expertReviews: 'Avis des experts',
    adVideoScore: 'Indice d’efficacité publicitaire',
    subjectiveResponseCurve: 'Courbe de réponse subjective',
    indexAnalysis: 'Analyse des indices',
    keyResult: 'Résultat clé',
    theGolden3Seconds: 'Les 3 secondes d’or',
    informationTransmission: 'Moment d’information',
    brandRelevance: 'Moment de marque',
    interestStimulation: 'Moment d’intérêt',
    theEnding3Seconds: 'Les 3 dernières secondes',
    heatMap: 'Carte thermique',
    suggestion: 'Suggestions',
    suggestion1: 'Suggestion',
    submit: 'Envoyer',
    next: 'Suivant',
    summary: 'Résumé',
    advantages: 'Avantages',
    disadvantages: 'Inconvénients',
    option1: 'Prévu',
    option2: 'Non prévu',
    resultJudgment: 'Évaluation',
    placeholder: 'Veuillez entrer une suggestion',
    waitRateCount: 'Nombre d’annonces à évaluer',
    unfinishedTitle: 'Notification',
    unfinishedRate: 'L’évaluation contient des éléments incomplets',
    unfinishedConfirm: 'Continuer l’évaluation',
    unfinishedCancel: 'Quitter',
    message: {
      submitSuccess: 'Merci pour votre évaluation',
      submitSuccess1: 'Vous avez terminé l’évaluation de ce projet, merci pour votre évaluation',
      loginSuccess: 'Connexion réussie',
      rateUnfinished:
        "Vous n'avez pas encore évalué le contenu actuel, veuillez le remplir avant de passer à la question suivante",
      rateLocation: 'Nous avons automatiquement sélectionné les éléments incomplets pour vous',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Faire une demande de test',
      title1: 'Test gratuit',
      trial: 'Test',
      hiddenBoxText1: 'Plusieurs avantages, inconvénients et suggestions détectés',
      hiddenBoxText2: 'Souscrire pour obtenir le rapport complet',
      hiddenBoxBtn: 'Souscrire maintenant',
      applyBox: {
        name: 'Votre nom',
        tel: 'Numéro de contact',
        department: 'Département',
        role: 'Rôle',
        country: 'Pays',
        city: 'Ville',
        pleaseEnter: 'Veuillez entrer',
        pleaseSelect: 'Veuillez sélectionner',
        pleaseEnterTheName: 'Veuillez entrer votre nom',
        pleaseEnterTheTel: 'Veuillez entrer votre numéro de contact',
        pleaseEnterValidTel: 'Veuillez entrer un numéro de contact valide',
        pleaseEnterValidEmail: 'Veuillez entrer une adresse e-mail valide',
        pleaseSelectTheDepartment: 'Veuillez sélectionner votre département',
        pleaseSelectTheRole: 'Veuillez sélectionner votre rôle',
        pleaseSelectTheCountry: 'Veuillez sélectionner votre pays',
        pleaseEnterTheCity: 'Veuillez entrer votre ville',
        textIsRequired: 'Ce champ est obligatoire',
        submit: 'Envoyer',
        tip: 'Chaque entreprise a seulement une opportunité de test gratuit',
      },
      gotTrial: 'Vous avez reçu un test !',
      goPc: 'Veuillez aller à la version web de PC pour créer votre projet.',
      back: 'Retour',
      country: {
        China: 'Chine',
        Japan: 'Japon',
        Korea: 'Corée',
        Indonesia: 'Indonésie',
        Thailand: 'Thaïlande',
        Singapore: 'Singapour',
        Malaysia: 'Malaisie',
        Vietnam: 'Vietnam',
        Germany: 'Allemagne',
        Britain: 'Royaume-Uni',
        France: 'France',
        Italy: 'Italie',
        Russia: 'Russie',
        Spain: 'Espagne',
        Turkey: 'Turquie',
        America: 'États-Unis',
        Canada: 'Canada',
        Brazil: 'Brésil',
        Other: 'Autre',
      },
      department: {
        Brand: 'Marque',
        Market: 'Marché',
        Marketing: 'Marketing',
        IT: 'IT',
        Procurement: 'Achat',
        Other: 'Autre',
      },
      role: {
        President: 'Président/Vice-président/Directeur général',
        CMO: 'CMO ou Autre gestion de niveau C',
        Director: 'Directeur de département',
        Manager: 'Gestionnaire de département',
        Other: 'Autre',
      },
      message: {
        submitSuccess: 'Soumission réussie',
        submitFailed: 'Soumission échouée, veuillez réessayer plus tard',
      },
    },
    downloadPptRechargeModal: {
      title: 'Impossible de télécharger le rapport',
      desc1: 'Dans la version de test, vous ne pouvez pas télécharger le rapport',
      desc2: 'Souscrire pour obtenir le rapport complet',
      btn: 'Souscrire maintenant',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Code de parrainage',
      invitationCodeDesc1:
        'Le code de parrainage ne peut pas être modifié, veuillez nous contacter si vous souhaitez le modifier',
      invitationCodeDesc2:
        "Si vous utilisez ceci par le biais d'un parrainage d'agent, veuillez entrer le code de parrainage",
      invitationCodePlaceholder: 'Veuillez entrer le code de parrainage',
      invitationCodeError: 'Code de parrainage invalide',
      invitationCodeSuccess: 'Code de parrainage mis à jour avec succès',
      ok: 'OK',
      cancel: 'Annuler',
    },
    aigcPromotionModal: {
      title: 'Avantages Créateur AIGC',
      subTitle:
        "Inscrivez-vous maintenant pour obtenir <tmp>5</tmp> opportunités d'évaluation vidéo IA",
      desc1: "Rejoignez l'événement de test créatif IA d'AdEff pour évaluer vos créations.",
      desc2: 'Inscrivez-vous maintenant et obtenez instantanément 5 tests gratuits.',
      registerBtn: "S'inscrire pour obtenir des tests",
      tip: "Réservé aux nouveaux utilisateurs inscrits via l'entrée de campagne Créateur AIGC",
      floatTitle: 'Test gratuit',
    },
  },
}

export default TRANSLATION
